import { JSONSchema7 } from 'json-schema';
import { types as commonTypes } from '@sitebuilder/common';
import CustomQueriesView from './CustomQueries';

const schema: JSONSchema7 = {
    title: 'Custom Queries',
    type: 'object',
    required: [],
    properties: {
        dataSourceType: {
            type: 'string',
            description: 'Data Source Type',
            enum: ['', 'GraphQL'],
            default: '',
        },
        dataSource: {
            type: 'string',
            description: 'data Source',
            default: '',
        },
        query: {
            type: 'string',
            description: 'A graphql query',
            default: '',
        },
        queryVariables: {
            type: 'string',
            description: 'Query variables',
            default: '',
        },
        transform: {
            type: 'string',
            description: 'A transform function to transform the graphql query results',
            default: '',
        },
        isLazyLoad: {
            type: 'boolean',
            description: 'Lazy load the Query',
            default: false,
        },
    },
};

const groups = [
    {
        Values: [
            'dataSourceType',
            'dataSource',
            'query',
            'queryVariables',
            'transform',
            'isLazyLoad',
        ],
    },
];

const CustomQueries: commonTypes.IWidget = {
    // without default
    schema,
    uiSchema: {
        'ui:groups': groups,
        dataSourceType: {
            'ui:widget': 'CustomSelect',
        },
        dataSource: {
            'ui:widget': 'CustomTextInput',
        },
        query: {
            'ui:widget': 'JSEditor',
        },
        queryVariables: {
            'ui:widget': 'JSEditor',
        },
        transform: {
            'ui:widget': 'JSEditor',
        },
        isLazyLoad: {
            'ui:widget': 'CustomCheckbox',
        },
    },
    templateView: CustomQueriesView,
    id: 'CustomQueries',
    group: 'data',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        query: '',
    }),
};

export default CustomQueries;
